var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "602.187pt",
    height: "515.868pt",
    viewBox: "0 0 602.187 515.868",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "rgb(100%, 0%, 19.999695%)",
    fillOpacity: 1,
    d: "M 261.203125 317.3125 L 363.890625 257.722656 L 261.203125 198.425781 Z M 146.078125 388.179688 C 129.011719 383.550781 115.707031 369.957031 110.789062 353.179688 C 102.6875 322.226562 102.6875 257.722656 102.6875 257.722656 C 102.6875 257.722656 102.6875 193.21875 110.789062 162.558594 C 115.707031 145.492188 129.011719 132.183594 146.078125 127.554688 C 176.738281 119.167969 300.542969 119.167969 300.542969 119.167969 C 300.542969 119.167969 424.636719 119.167969 455.296875 127.554688 C 472.652344 132.183594 485.667969 145.492188 490.296875 162.558594 C 498.6875 193.21875 498.6875 257.722656 498.6875 257.722656 C 498.6875 257.722656 498.6875 322.226562 490.296875 353.179688 C 485.667969 369.957031 472.652344 383.550781 455.296875 388.179688 C 424.636719 396.570312 300.542969 396.570312 300.542969 396.570312 C 300.542969 396.570312 176.738281 396.570312 146.078125 388.179688 "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "rgb(100%, 100%, 100%)",
    fillOpacity: 1,
    d: "M 261.203125 317.3125 L 363.890625 257.722656 L 261.203125 198.425781 Z M 261.203125 317.3125 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.19a3fe389e92ab51db78be20693af024.svg";
export { ForwardRef as ReactComponent };